(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (function () {
    var countEl = document.getElementById('ProductCount');
    var applyBtn = document.querySelector('.sugoi-apply-btn');
    if (!countEl || !applyBtn) return;

    function syncApplyButton() {
      var count = parseInt(countEl.getAttribute('data-product-count'), 10);
      if (isNaN(count)) return;
      applyBtn.textContent = 'Voir ' + count + ' résultat' + (count > 1 ? 's' : '');
    }

    new MutationObserver(syncApplyButton).observe(countEl, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-product-count'],
    });
  })();

  // Dawn's <menu-drawer>.bindEvents() re-attaches click listeners on every
  // summary/button it contains (via addEventListener, never removed), and
  // facets.js calls bindEvents() again after every AJAX filter update. Since
  // our drawer's toggle button and global footer buttons are never recreated
  // by that AJAX patching, listeners pile up: after one filter interaction a
  // single click fires the open/close handler twice and cancels itself out,
  // freezing the drawer. Make bindEvents a no-op after its first run, but
  // only for our facets drawer so other menu-drawer usages are untouched.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('menu-drawer').then(function () {
      var proto = customElements.get('menu-drawer').prototype;
      if (proto.__sugoiBindEventsPatched) return;
      proto.__sugoiBindEventsPatched = true;
      var originalBindEvents = proto.bindEvents;
      proto.bindEvents = function () {
        if (this.classList.contains('mobile-facets__wrapper')) {
          if (this.__sugoiEventsBound) return;
          this.__sugoiEventsBound = true;
        }
        return originalBindEvents.apply(this, arguments);
      };

      // closeMenuDrawer() also strips the "open" attribute from every
      // nested <details> when the drawer closes (native Dawn cleanup for
      // its drill-down submenus). Our filter groups are meant to stay
      // permanently expanded (flattened list, not a drill-down), and since
      // later AJAX updates only ever replace their innerHTML (never the
      // <details> element itself), a stripped "open" never comes back:
      // the group looks collapsed/empty forever after the first close.
      // Re-open our filter groups right after Dawn's own close logic runs.
      var originalCloseMenuDrawer = proto.closeMenuDrawer;
      proto.closeMenuDrawer = function () {
        var isFacetsDrawer = this.classList.contains('mobile-facets__wrapper');
        var result = originalCloseMenuDrawer.apply(this, arguments);
        if (isFacetsDrawer) {
          this.querySelectorAll('.mobile-facets__details').forEach(function (details) {
            details.setAttribute('open', '');
          });
        }
        return result;
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // First click/tap on the card only "arms" it (highlight, same look as
    // :hover), a second click/tap on the same still-armed card follows the
    // link to the product page. Applies uniformly regardless of input type.
    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.sugoi-card-link');
        if (!link) return;
        var card = link.closest('.sugoi-product-card');
        if (!card) return;

        // Let modified/middle clicks (open in new tab, etc.) behave natively.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        event.preventDefault();

        if (card.classList.contains('is-armed')) {
          window.location.href = link.href;
          return;
        }

        document.querySelectorAll('.sugoi-product-card.is-armed').forEach(function (other) {
          other.classList.remove('is-armed');
        });
        card.classList.add('is-armed');
      },
      true
    );

    document.addEventListener('click', function (event) {
      if (event.target.closest('.sugoi-product-card')) return;
      document.querySelectorAll('.sugoi-product-card.is-armed').forEach(function (card) {
        card.classList.remove('is-armed');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["restock-notify-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-restock-trigger]');
      if (!trigger) return;
      event.preventDefault();

      var modal = document.getElementById('RestockNotifyModal');
      if (!modal) return;

      var handle = trigger.getAttribute('data-restock-handle') || '';
      var title = trigger.getAttribute('data-restock-title') || '';
      var tagInput = modal.querySelector('[data-restock-tag-input]');
      var titleEl = modal.querySelector('[data-restock-product-title]');
      if (tagInput) tagInput.value = 'restock-' + handle;
      if (titleEl) titleEl.textContent = title;

      modal.show(trigger);
    });

    document.addEventListener('DOMContentLoaded', function () {
      var modal = document.getElementById('RestockNotifyModal');
      if (modal && modal.querySelector('[data-restock-open-on-load]')) {
        modal.show();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sugoi-marquee-sync"] && !Shopify.designMode) return;
  try {
    (function () {
    // The track starts CSS-paused (see .sugoi-marquee-auto) so it never
    // actually plays with the "-50%" fallback: updating a custom
    // property that an animation is already mid-flight on can make
    // browsers visibly hiccup/flash while they recompute the keyframe.
    // Measure once, set the real value, THEN start the animation.
    //
    // That alone isn't enough though: the very first sync can run
    // before self-hosted webfonts have swapped in (font-display:swap
    // means text first lays out in the fallback font), so a LATER
    // sync - once document.fonts.ready resolves, or on resize - can
    // find the real distance moved and needs to correct an animation
    // that's already running by then. Pause it first, update the
    // custom property, force a reflow so the browser actually picks
    // the new value up, then resume - same fix as the initial
    // start-paused-until-ready, just applied to every re-sync too.
    function syncTrack(track) {
      var count = track.children.length;
      if (count < 2) return;

      // Tracks that render a variable number of copies (e.g. avis.liquid,
      // which repeats more times when few reviews are configured so the
      // strip is always wide enough to feel infinite) declare how many
      // items make up ONE copy via data-items-per-copy. Tracks that
      // always render exactly two copies don't set it, so fall back to
      // assuming the children split evenly in half.
      var itemsPerCopy = parseInt(track.getAttribute('data-items-per-copy'), 10);
      if (!itemsPerCopy || itemsPerCopy <= 0 || itemsPerCopy >= count) {
        if (count % 2 !== 0) return;
        itemsPerCopy = count / 2;
      }

      var first = track.children[0];
      var second = track.children[itemsPerCopy];
      if (!second) return;
      var distance = second.getBoundingClientRect().left - first.getBoundingClientRect().left;
      if (distance <= 0) return;

      // A resync that "corrects" a sub-pixel/measurement-noise
      // difference still pauses and resumes the animation, which is
      // itself a tiny, visible hitch - only bother for a difference
      // big enough to have mattered in the first place.
      var current = Math.abs(parseFloat(track.style.getPropertyValue('--sugoi-marquee-distance')) || 0);
      if (Math.abs(current - distance) < 2) return;

      var wasReady = track.classList.contains('sugoi-marquee-ready');
      if (wasReady) track.style.animationPlayState = 'paused';

      track.style.setProperty('--sugoi-marquee-distance', '-' + distance + 'px');
      track.classList.add('sugoi-marquee-ready');

      if (wasReady) {
        void track.offsetWidth; // force a reflow before resuming
        track.style.animationPlayState = '';
      }
    }

    function syncAll() {
      document.querySelectorAll('.sugoi-marquee-auto').forEach(syncTrack);
    }

    // Only "fonts.ready" is kept as a follow-up trigger, not "load" too:
    // none of the marquee content depends on images, so a second pass
    // there almost never finds a real change and just adds another
    // chance to catch measurement noise and pause/resume for nothing.
    syncAll();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAll);
    }

    // Mobile browsers fire "resize" when their address bar shows/hides
    // on scroll, which changes viewport HEIGHT only - re-measuring for
    // that is pure noise. Only real width changes (rotation, actual
    // window resize) can change how this content wraps/lays out.
    var lastWidth = window.innerWidth;
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncAll, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
